export default __webpack_public_path__ + "static/media/06.6e22717c.jpg";